module.exports = __webpack_public_path__ + "static/img/c1.335a0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/c1.png
// module id = fcAR
// module chunks = 0